import { IOffer } from '../../../types/offer';
import { plural } from '@cian/utils';

export function getRoomTitle(offer: IOffer) {
  return offer.roomsForSaleCount
    ? `${offer.roomsForSaleCount} ${plural(offer.roomsForSaleCount, ['комната', 'комнаты', 'комнат'])}`
    : '1 комната';
}
